export type { ConsumableQuantityEstimationProps } from './consumable-quantity-estimation';
export * from './consumable-quantity-estimation.routes';

export { default as ConsumableQuantityEstimation, default } from './consumable-quantity-estimation';
